import { useState, ReactNode } from 'react';
import { hapticFeedback } from '@telegram-apps/sdk';
import './Cards.css';

interface AccordionCardProps {
  icon?: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function AccordionCard({
  icon,
  title,
  subtitle,
  children,
  defaultOpen = false,
}: AccordionCardProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleClick = () => {
    if (hapticFeedback.impactOccurred.isAvailable()) {
      hapticFeedback.impactOccurred('light');
    }
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion-card">
      <div className="accordion-header" onClick={handleClick}>
        {icon && <span className="accordion-icon">{icon}</span>}
        <div className="accordion-header-content">
          <div className="accordion-title">{title}</div>
          {subtitle && <div className="accordion-subtitle">{subtitle}</div>}
        </div>
        <span className={`accordion-chevron ${isOpen ? 'accordion-chevron--open' : ''}`}>
          ▼
        </span>
      </div>
      <div className={`accordion-content ${isOpen ? 'accordion-content--open' : ''}`}>
        <div className="accordion-content-inner">
          <div className="accordion-content-padding">{children}</div>
        </div>
      </div>
    </div>
  );
}
